<template lang='pug'>
  carousel.carousels.services.component(
    :perPageCustom="[[180, 1], [360, 2], [540, 3], [720, 4], [900, 5]]"
    :key='srvs.length'
  )
    slide.slide( v-for='s, i in srvs' :key='s.id' )
      srv-card( :srv='s' @click.native='$emit("select", s)' :collection='collection' )
</template>

<script>
  import { db } from '@/main'
  import { Carousel, Slide } from 'vue-carousel'
  import SrvCard from '@/components/cards/service'

  export default {
    name: 'carousels.services.component',

    components: {
      SrvCard,
      Carousel,
      Slide,
    },

    props: {
      user: Object,
      account: [ Object, Array ],
      merchant: { default: false },
      srvs: { default: () => ([]) },
      collection: { type: String, default: 'services' }
    }
  }
</script>

<style scoped lang='stylus'>
  .slide
    .cards.service
      margin-left 16px
    &:first-child .cards.service
      margin-left 0
    &:last-child .cards.service
      margin-right 0
</style>
